module.exports = __webpack_public_path__ + "img/HITACHI.696597a9.png";